import * as React from 'react';
import { Grid } from '../bootstrap-components/BootstrapComponents';

export interface ContentWrapperProps {
    children?: any;
    className?: string;
}

export function ContentWrapper(props: ContentWrapperProps) {
    let className = 'content-wrapper';

    if (props.className !== undefined) {
        className += ' ' + props.className;
    }

    return (
        <div id='content-wrapper' className={className}>
            <Grid>
                {props.children}
            </Grid>
        </div>
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/ContentWrapper.tsx